import { useScrollAnimation } from '../hooks/useScrollAnimation';
import CourseBundlesSection from '../components/layout/CourseBundlesSection';
import '../styles/scrollAnimations.css';

const CourseBundlesPage = () => {
  const { ref: bundlesRef, isVisible: bundlesVisible } = useScrollAnimation({ 
    threshold: 0.1, 
    delay: 0, 
    rootMargin: '0px 0px -80px 0px' 
  });

  return (
    <div className="overflow-x-hidden">
      {/* Page Header */}
      <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white py-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in">
            AI Testing <span className="bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">Course Bundles</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed animate-fade-in" style={{animationDelay: '200ms'}}>
            Save money and accelerate your learning with our carefully curated course bundles. 
            Choose the perfect path for your career level and goals.
          </p>
        </div>
      </div>

      {/* Course Bundles Section */}
      <div 
        ref={bundlesRef}
        className={`section-reveal ${bundlesVisible ? 'animate' : ''}`}
      >
        <CourseBundlesSection />
      </div>
    </div>
  );
};

export default CourseBundlesPage;